import * as localforage from "localforage";
import { generateRecursiveList } from "../helpers/generateRecursiveList";
import { flatMultiDimensional } from "../helpers/flatMultiDimensional";
import { phpRequest } from "./phpRequest";

export const getSubCompanyAPI = async () => {

  const companyId = await localforage.getItem("userCompanyID");

  const data = await phpRequest.get("/sub-companies", {
    company_id: companyId,
  });

  if (data && data.companies) {
    let originalData = data.companies;
    const subCompaniesArr = generateRecursiveList(data.companies);
    await localforage.setItem(
      "subCompanies",
      flatMultiDimensional(subCompaniesArr)
    );
    await localforage.setItem("subCompaniesOriginalData", originalData);
    return originalData;
  }
  return [];
};
